<template>
  <BaseTooltip :text="text" :position="position">
    <div v-if="filled" class="tooltip-icon tooltip-icon--filled">
      <svg
        width="10"
        height="10"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <div v-else class="tooltip-icon">*</div>
  </BaseTooltip>
</template>

<script>
export default {
  name: "BaseLabelTooltip",

  props: {
    text: {
      type: String,
      required: true,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: "right",
      validator: (value) =>
        ["top", "bottom", "left", "right"].includes(value),
    },
  },
};
</script>

<style scoped>
.tooltip-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  color: var(--color-danger);
  font-size: 18px;
  font-weight: bold;
  transition: color 0.2s ease;
  line-height: 1;
}

.tooltip-icon--filled {
  color: #a3cfb4;
}

.tooltip-icon svg {
  display: block;
}
</style>
